import { radiansToAzimuth } from '../../../../utils/mathUtilities';
import { XyzPoint } from '../../../../models/SurveyEngineering/XyzPoint';

// The algorithms for various transform operations are ported from the Java source code of the EFT desktop .

export function calcRotationAngle(
  pivotRefPt: XyzPoint,
  pivotTargetPt: XyzPoint,
  angleRefPt: XyzPoint,
  angleTargetPt: XyzPoint
) {
  // compute angle from pivotRef to angleRef (in survey space)
  const dx = angleRefPt.getX() - pivotRefPt.getX();
  const dy = angleRefPt.getY() - pivotRefPt.getY();
  const surveyPhase = Math.atan2(dy, dx);
  const surveyBearing = radiansToAzimuth(surveyPhase);

  // compute angle from pivotTarget to angleTarget (in ground surface space)
  const dx2 = angleTargetPt.getX() - pivotTargetPt.getX();
  const dy2 = angleTargetPt.getY() - pivotTargetPt.getY();
  const gsPhase = Math.atan2(dy2, dx2);
  const gsBearing = radiansToAzimuth(gsPhase);

  // rotation angle is GS - survey bearings
  let rotateAngle = gsBearing - surveyBearing;

  // limit to (-180, 180)
  while (rotateAngle > 180.0) rotateAngle -= 360.0;
  while (rotateAngle < -180.0) rotateAngle += 360.0;
  // if (rotateAngle > 180.0) rotateAngle -= 360.0;
  // if (rotateAngle < -180.0) rotateAngle += 360.0;

  // registration error is delta-distance
  const dist = Math.sqrt(dx * dx + dy * dy);
  const dist2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
  const regErr = Math.abs(dist - dist2);

  return [rotateAngle, regErr];
  // const errValue = String.format("%.1f", regErr);
  // regErrorText.setText(errValue);
}
